const MAX_LOG_LEN = 4096;

/**
 * Safely serialise a payload for logging. JSON.stringify escapes control
 * characters (\r\n -> \\r\\n), neutralising log/CRLF injection, and we cap
 * the length so a malicious oversized body cannot bloat the log pipeline.
 */
export const safeStringifyForLog = (value: unknown): string => {
  try {
    const json = JSON.stringify(value) ?? 'undefined';
    return json.length > MAX_LOG_LEN
      ? `${json.slice(0, MAX_LOG_LEN)}…[truncated ${json.length - MAX_LOG_LEN} chars]`
      : json;
  } catch {
    return '[unserialisable payload]';
  }
};
